var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.reRender, staticClass: "answer-result-detail-main" },
    [
      _vm.exam && !_vm.userExam.finishedAt
        ? _c(
            "div",
            {
              staticClass:
                "answer-result-detail d-flex justify-content-center flex-wrap",
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-alert", { attrs: { value: true, type: "warning" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("exam_result.warning_finish_exam", {
                            format: _vm.LETTER_FORMAT.UPTITLECASE,
                          })
                        ) +
                        "\n      "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : !_vm.mobile && _vm.exam && _vm.userExam.finishedAt
        ? _c(
            "div",
            {
              staticClass:
                "answer-result-detail d-flex justify-content-center flex-wrap",
            },
            [
              _vm.exam && _vm.currentGroup && _vm.exam.questions
                ? _c("v-flex", { attrs: { xs12: "" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex",
                        staticStyle: { "flex-wrap": "wrap" },
                      },
                      [
                        _c(
                          "multipane",
                          {
                            staticStyle: { flex: "1" },
                            attrs: { layout: "vertical" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "75%",
                                  "max-width": "100%",
                                },
                              },
                              [
                                _vm.getBanner("question_result_top")
                                  ? [
                                      _c("div", {
                                        staticClass: "banner",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.getBanner("question_result_top")
                                              .bodyHtml
                                          ),
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-card",
                                  { staticClass: "p-0 green-bgr" },
                                  [
                                    _c(
                                      "v-card-title",
                                      { staticClass: "white-text px-0" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "ps-0 ms-1 white-text",
                                            attrs: { text: "" },
                                            on: { click: _vm.backToExamResult },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { left: "" } },
                                              [_vm._v("navigate_before")]
                                            ),
                                            _vm._v(" "),
                                            _c("v-toolbar-title", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("common.result", {
                                                      format:
                                                        _vm.LETTER_FORMAT
                                                          .UPTITLECASE,
                                                    })
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "title w-100 mt-0 text-center",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.currentGroup
                                                    .isDescriptionQuestion
                                                    ? _vm.$t(
                                                        "exam_result.description",
                                                        {
                                                          format:
                                                            _vm.LETTER_FORMAT
                                                              .UPTITLECASE,
                                                        }
                                                      )
                                                    : _vm.currentIndex +
                                                        " " +
                                                        _vm.$t(
                                                          "exam_result.problem",
                                                          {
                                                            format:
                                                              _vm.LETTER_FORMAT
                                                                .UPTITLECASE,
                                                          }
                                                        )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-wrap d-flex result-title w-full",
                                        },
                                        [
                                          _vm.currentGroup.isWorkSheet
                                            ? _c(
                                                "v-flex",
                                                { attrs: { xs4: "" } },
                                                [
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      staticClass: "m-2",
                                                      attrs: {
                                                        color: "orange",
                                                        "text-color": "white",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "question.work_sheet"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { right: "" },
                                                        },
                                                        [_vm._v("star")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isShowBody && _vm.currentGroup
                                            ? [
                                                _vm._l(
                                                  _vm.currentGroup.questions,
                                                  function (item, index) {
                                                    return [
                                                      _c(
                                                        "ExamResultQuestionBodyWeb",
                                                        {
                                                          key: index,
                                                          attrs: {
                                                            id:
                                                              "question_" +
                                                              item.id,
                                                            groupIndex:
                                                              _vm.currentIndex,
                                                            currentQuestion:
                                                              item,
                                                            index: index + 1,
                                                            isMultipleQuestion:
                                                              _vm.currentGroup
                                                                .questions
                                                                .length > 1,
                                                            schoolSetting:
                                                              _vm.schoolSetting,
                                                            examQScoreHistory:
                                                              _vm.examQScoreHistory,
                                                            exam: _vm.exam,
                                                            "user-exam":
                                                              _vm.userExam,
                                                          },
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        key: "divider" + index,
                                                        staticClass: "divider",
                                                      }),
                                                    ]
                                                  }
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.getBanner(
                                            "question_result_bottom"
                                          )
                                            ? [
                                                _c("div", {
                                                  staticClass: "banner",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.getBanner(
                                                        "question_result_bottom"
                                                      ).bodyHtml
                                                    ),
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-actions",
                                      {
                                        staticClass: "footer-card-question p-3",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center w-full",
                                          },
                                          [
                                            _c("v-spacer"),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "m-1",
                                                attrs: {
                                                  text: "",
                                                  icon: "",
                                                  disabled: _vm.isFirstItem,
                                                },
                                                on: { click: _vm.first },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    最初\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "m-1",
                                                attrs: {
                                                  text: "",
                                                  icon: "",
                                                  disabled: _vm.isFirstItem,
                                                },
                                                on: { click: _vm.previous },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    前へ\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("v-spacer"),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "m-1",
                                                attrs: {
                                                  text: "",
                                                  icon: "",
                                                  disabled: _vm.isLastItem,
                                                },
                                                on: { click: _vm.next },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    次へ\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "m-1",
                                                attrs: {
                                                  text: "",
                                                  icon: "",
                                                  disabled: _vm.isLastItem,
                                                },
                                                on: { click: _vm.last },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    最後\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("v-spacer"),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.getBanner("question_result_bottom")
                                  ? [
                                      _c("div", {
                                        staticClass: "banner",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.getBanner(
                                              "question_result_bottom"
                                            ).bodyHtml
                                          ),
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("multipane-resizer", {
                              staticStyle: {
                                width: "2px",
                                border: "2px solid #e0e0e0",
                                margin: "0 5px",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                ref: "rightSideBar",
                                staticStyle: { "flex-grow": "1", width: "25%" },
                              },
                              [
                                _c(
                                  "v-card",
                                  {
                                    ref: "rightSideBarCard",
                                    staticClass: "p-0",
                                    staticStyle: {
                                      position: "fixed",
                                      height: "calc(100% - 95px)",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-card-title",
                                      { staticClass: "p-0 fill-height" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex w-100 fill-height",
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "fill-height",
                                                attrs: { xs12: "" },
                                              },
                                              [
                                                _c(
                                                  "v-tabs",
                                                  {
                                                    model: {
                                                      value: _vm.tab,
                                                      callback: function ($$v) {
                                                        _vm.tab = $$v
                                                      },
                                                      expression: "tab",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-tab",
                                                      { key: "question" },
                                                      [_vm._v("Questions")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.schoolSetting &&
                                                    _vm.schoolSetting
                                                      .useAiChatExam
                                                      ? _c(
                                                          "v-tab",
                                                          { key: "chat" },
                                                          [_vm._v("チャット")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.schoolSetting &&
                                                    _vm.schoolSetting
                                                      .useAiChatExam
                                                      ? _c(
                                                          "v-tab",
                                                          { key: "thread" },
                                                          [_vm._v("スレッド")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticStyle: {
                                                        "padding-right": "40px",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.schoolSetting &&
                                                    _vm.schoolSetting
                                                      .useAiChatExam
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "btn-new-chat",
                                                            attrs: {
                                                              icon: true,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.emitCreateThread(
                                                                  1
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "v-icon material-icons theme--dark",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "add_comment"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-tabs-items",
                                                  {
                                                    staticClass: "h-full",
                                                    model: {
                                                      value: _vm.tab,
                                                      callback: function ($$v) {
                                                        _vm.tab = $$v
                                                      },
                                                      expression: "tab",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-tab-item",
                                                      {
                                                        key: "question",
                                                        staticStyle: {
                                                          height:
                                                            "calc(100% - 30px)",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list",
                                                          {
                                                            staticClass:
                                                              "question-list-show question-list-scroll",
                                                          },
                                                          [
                                                            _vm._l(
                                                              _vm.groupQuestions,
                                                              function (
                                                                item,
                                                                index
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "ExamResultQuestionGroupList",
                                                                    {
                                                                      key:
                                                                        index +
                                                                        "group",
                                                                      attrs: {
                                                                        item: item,
                                                                        questionNumber:
                                                                          _vm.getQuestionNumber(
                                                                            item
                                                                          ),
                                                                        padding: true,
                                                                        selected:
                                                                          _vm.tabSelected,
                                                                        exam: _vm.exam,
                                                                        "user-exam":
                                                                          _vm.userExam,
                                                                        examQScoreHistory:
                                                                          _vm.examQScoreHistory,
                                                                      },
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  index + 1 <
                                                                  _vm
                                                                    .groupQuestions
                                                                    .length
                                                                    ? _c(
                                                                        "v-divider",
                                                                        {
                                                                          key:
                                                                            index +
                                                                            "group_divider",
                                                                          staticClass:
                                                                            "my-0",
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.schoolSetting &&
                                                    _vm.schoolSetting
                                                      .useAiChatExam
                                                      ? _c(
                                                          "v-tab-item",
                                                          {
                                                            key: "chat",
                                                            staticStyle: {
                                                              height:
                                                                "calc(100% - 30px)",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "MesageContainer",
                                                              {
                                                                key: _vm.tabSelected,
                                                                ref: "mesageContainer",
                                                                staticClass:
                                                                  "h-full",
                                                                attrs: {
                                                                  targetableId:
                                                                    _vm.tabSelected,
                                                                  targetableType:
                                                                    "Question",
                                                                  "using-deepseek":
                                                                    _vm
                                                                      .schoolSetting
                                                                      .usingDeepSeek,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.schoolSetting &&
                                                    _vm.schoolSetting
                                                      .useAiChatExam
                                                      ? _c(
                                                          "v-tab-item",
                                                          {
                                                            key: "thread",
                                                            staticStyle: {
                                                              height:
                                                                "calc(100% - 30px)",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "ThreadContainer",
                                                              {
                                                                key: _vm.tabSelected,
                                                                attrs: {
                                                                  targetableId:
                                                                    _vm.tabSelected,
                                                                  targetableType:
                                                                    "Question",
                                                                },
                                                                on: {
                                                                  updateParentTab:
                                                                    _vm.updateParentTab,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm.mobile && _vm.exam && _vm.userExam.finishedAt
        ? _c(
            "div",
            { staticClass: "answer-result-detail d-flex bg-white" },
            [
              _vm.exam && _vm.exam.questions
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _vm.getBanner("question_result_top")
                        ? [
                            _c("div", {
                              staticClass: "banner",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getBanner("question_result_top").bodyHtml
                                ),
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "green-bgr d-flex align-center justify-space-between p-2",
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ps-0 ms-1 white-text",
                              attrs: { text: "" },
                              on: { click: _vm.backToExamResult },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("navigate_before"),
                              ]),
                              _vm._v(" "),
                              _c("v-toolbar-title", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("common.result", {
                                        format: _vm.LETTER_FORMAT.UPTITLECASE,
                                      })
                                    ) +
                                    "\n          "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mobile-result-header white-text p-2",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.currentGroup &&
                                      _vm.currentGroup.isDescriptionQuestion
                                      ? _vm.$t("exam_result.description", {
                                          format: _vm.LETTER_FORMAT.UPTITLECASE,
                                        })
                                      : "" +
                                          (_vm.currentIndex +
                                            " " +
                                            _vm.$t("exam_result.problem", {
                                              format:
                                                _vm.LETTER_FORMAT.UPTITLECASE,
                                            }))
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "me-1",
                              attrs: { color: "white" },
                              on: { click: _vm.toResulQuestionLList },
                            },
                            [_vm._v("menu")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "m-0 ms-2 me-2" }),
                      _vm._v(" "),
                      _vm.isShowBody && _vm.currentGroup
                        ? [
                            _c(
                              "swipe",
                              {
                                ref: "swipe",
                                staticClass: "my-swipe",
                                attrs: {
                                  auto: 0,
                                  speed: 100,
                                  showIndicators: false,
                                  defaultIndex: 1,
                                  disabled: true,
                                },
                                on: { change: _vm.changeQuestion },
                              },
                              [
                                _c("swipe-item", { staticClass: "slide1" }),
                                _vm._v(" "),
                                _c(
                                  "swipe-item",
                                  { staticClass: "slide2" },
                                  _vm._l(
                                    _vm.currentGroup.questions,
                                    function (item, index) {
                                      return _c(
                                        "ExamResultQuestionBodyMobile",
                                        {
                                          key: index,
                                          attrs: {
                                            groupIndex: _vm.currentIndex,
                                            currentQuestion: item,
                                            index: index + 1,
                                            id: "question_" + item.id,
                                            isMultipleQuestion:
                                              _vm.currentGroup.questions
                                                .length > 1,
                                            schoolSetting: _vm.schoolSetting,
                                            examQScoreHistory:
                                              _vm.examQScoreHistory,
                                            exam: _vm.exam,
                                            "user-exam": _vm.userExam,
                                          },
                                        }
                                      )
                                    }
                                  ),
                                  1
                                ),
                                _vm._v(" "),
                                _c("swipe-item", { staticClass: "slide3" }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }